import http from "../../http-common";

const getGroups = (user) => {
  return http.get(`/api/v1/teams/tags?user=${user}`);
};
const getAgents = (groupName, user) => {
  return http.get(`/api/v1/teams/agents/?groupName=${groupName}&user=${user}`);
};
const getActualQueues = (token, username) => {
  return http.get(
    `/api/v1/teams/stats/actualQueues?limit=99999&token=${token}&username=${username}`
  );
};
const getAgentsList = (groupName, user) => {
  return http.get(`/api/v1/teams/agents/simple?groupName=${groupName}&user=${user}`);
};

const postNewGroup = (body) => {
  return http.post("/api/v1/teams/groups", body);
};
const TagsService = {
  getGroups,
  getAgents,
  getActualQueues,
  getAgentsList,
  postNewGroup,
};

export default TagsService;
